module.exports = "/_next/static/images/06-bf1c755deb3616ccdf474ab013d594f9.png";